import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  ListItem,
  ListItemIcon,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import ChatIcon from "@material-ui/icons/Chat";
import Clear from "@material-ui/icons/Clear";
import Delete from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DialogAppBar from "../../../Components/DialogAppBar";
import {
  AWS_IMAGE_HOSTING_TAG,
  checkRequiredPermissions,
  ECABIN,
  formatClientInfoString,
  formatGoogleDriveMediaLink,
  formatTimeWithTZOffset,
  getToken,
  getUser,
  invoiceIssuers,
  paymentStates,
  requestErrorHandler,
  USER_GROUPS,
  warehouseLocation,
} from "../../../Utils/Common";
import SupplierCompanyTab from "../SupplierCompanyTab";

import SortableTable from "../../../Components/SortableTable";
import TagNameSearchAutocomplete from "../../../Components/TagNameSearchAutocomplete";
import { showPopupSnackbar } from "../../../redux/actions/snackbarActions";
import EnvSettings from "../../../Utils/EnvSettings";
import { useStyles } from "../../../Utils/Styles";
import DetailTabs from "../../../Views/DeviceDetails/DetailTabs";
import ShippingInformationTab from "../ShippingInformationTab";
import WarehouseTab from "../WarehouseTab";
import PackageDialog from "./PackageDialog";

const server = EnvSettings.server;

export default function EditStockItemDialog({
  edit,
  setEdit,
  addStockQuantity,
  resupplys,
  orders,
  otherWarehouses,
}) {
  const [editedValues, setEditedValues] = useState();
  const [editImgUrl, setEditImgUrl] = useState(false);
  const [editPackage, setEditPackage] = useState();
  const [selectedWarehouse, setSelectedWarehouse] = useState();
  const [stockChanges, setStockChanges] = useState();
  const dispatch = useDispatch();
  const [files, setFiles] = useState();
  const [tagList, setTagList] = useState([]);
  const [autocompKey, setAutocompKey] = useState("sfsadfas");
  const { t } = useTranslation();
  const classes = useStyles();
  const fileUploadRef = useRef();
  const deleteStockItem = (itemid) => {
    if (!itemid) {
      return;
    }
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token: getToken(),
        stockItemId: itemid,
      }),
    };
    fetch(server + "/delete_stock_item", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          window.location.reload();
        }
      });
  };

  const uploadPhoto = (e) => {
    if (!files && !!files.length) {
      return;
    }
    const data = new FormData();
    data.append("token", getToken());
    data.append("files[]", files);
    data.append(
      "resource",
      JSON.stringify({ type: "StockItem", number: edit.StockItem.sku })
    );
    fetch(server + "/upload_media_files", {
      method: "POST",
      body: data,
    })
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        dispatch(showPopupSnackbar(result));
        if (!result.error) {
          fileUploadRef.current.value = null;
          addStockQuantity({
            sku: edit.StockItem.sku,
            name: edit.StockItem.name,
            imageUrl:
              AWS_IMAGE_HOSTING_TAG + edit.StockItem.sku + "/" + files.name,
          });
        }
      });
  };

  const getMap = () => {
    if (editedValues && editedValues?.Tags) {
      return [...editedValues?.Tags];
    }
    return [];
  };

  useEffect(() => {
    const getStockChanges = (wid) => {
      setStockChanges();
      if (!edit || !edit.StockItem || !wid) {
        return;
      }
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: getToken(),
          stock_item_id: edit.StockItem.id,
          warehouse_id: wid,
        }),
      };
      fetch(server + "/get_stock_changes", requestOptions)
        .then((res) => res.json())
        .then((result) => {
          requestErrorHandler(result, dispatch);
          if (!result.error) {
            setStockChanges(result.stock);
          }
        });
    };
    if (selectedWarehouse && edit) {
      getStockChanges(
        selectedWarehouse === edit?.Warehouse.name
          ? edit.Warehouse.id
          : otherWarehouses.find(
              (o) =>
                o.StockItem.id === edit.StockItem.id &&
                o.Warehouse.name === selectedWarehouse
            )?.Warehouse.id
      );
    }
  }, [selectedWarehouse, setStockChanges, dispatch]);

  // Returns true if the values match
  const compareArrays = () => {
    if (!editedValues) {
      return true;
    }
    var keys = Object.keys(editedValues).filter((f) => f !== "warehouse");
    if (!keys.length) {
      return true;
    }
    var skipped = [
      "packages",
      "hsCodes",
      "weight",
      "Tags",
      "StockItemSupplierDetail",
    ];
    var array = keys.filter((f) => !skipped.find((fi) => fi === f));
    for (let index = 0; index < array.length; index++) {
      const element = array[index];
      if (editedValues[element] !== edit[element]) {
        return false;
      }
    }
    if (editedValues.StockItemSupplierDetail && !edit.StockItemSupplierDetail) {
      return false;
    }
    if (editedValues.StockItemSupplierDetail) {
      array = keys;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (
          editedValues.StockItemSupplierDetail[element] !==
          edit.StockItemSupplierDetail[element]
        ) {
          return false;
        }
      }
    }

    if (
      editedValues &&
      ((editedValues.packages &&
        JSON.stringify(editedValues.packages) !==
          JSON.stringify(edit?.StockItem?.PackingDetail?.packages)) ||
        (editedValues.hsCodes &&
          JSON.stringify(editedValues.hsCodes) !==
            JSON.stringify(edit?.StockItem?.PackingDetail?.hsCodes)) ||
        (editedValues.weight &&
          editedValues.weight !==
            String(edit?.StockItem?.PackingDetail?.weight)))
    ) {
      return false;
    }
    if (!editedValues?.Tags && !tagList.length) {
      return false;
    }
    return (
      JSON.stringify(editedValues?.Tags?.sort((a, b) => (a > b ? -1 : 1))) ===
      JSON.stringify(
        edit.StockItem.StockItemGroups.sort((a, b) =>
          a.StockItemGroupName.name > b.StockItemGroupName.name ? -1 : 1
        ).map((sig) => sig.StockItemGroupName.name)
      )
    );
  };

  const handleExit = () => {
    setEdit();
    setEditedValues();
    setEditImgUrl(false);
    setStockChanges();
    setSelectedWarehouse();
  };

  useEffect(() => {
    if (edit) {
      var o = { ...editedValues };
      if (edit?.StockItem.StockItemGroups.length) {
        o = {
          ...o,
          Tags: edit.StockItem.StockItemGroups.map(
            (tt) => tt.StockItemGroupName.name
          ),
        };
      }
      if (edit.StockItem?.PackingDetail?.packages?.length) {
        o = {
          ...o,
          packages: edit.StockItem.PackingDetail.packages,
        };
      }
      setSelectedWarehouse(edit?.Warehouse.name);
      setEditedValues({ ...o });
    }
    // eslint-disable-next-line
  }, [edit]);

  return (
    <Dialog open={!!edit} onClose={handleExit} fullScreen>
      <PackageDialog
        pack={editPackage}
        setPack={setEditPackage}
        _edit={editedValues}
        _setEdit={setEditedValues}
      />
      {edit ? (
        <div
          style={{
            width: "100%",
            height: 60,
            padding: 10,
            backgroundColor: "#f5f5f5",
            position: "fixed",
            bottom: 0,
            left: 0,
            zIndex: 9999,
            display: compareArrays() ? "none" : "",
          }}
        >
          <Button
            disabled={compareArrays()}
            style={{ marginLeft: 50 }}
            variant="contained"
            color="primary"
            onClick={() => {
              var obj = { ...edit };
              if (editedValues.free || editedValues.total) {
                if (edit.Warehouse.name === selectedWarehouse) {
                  obj = {
                    ...obj,
                    free: isNaN(editedValues.free)
                      ? edit.free
                      : editedValues.free,
                    total: isNaN(editedValues.total)
                      ? edit.total
                      : editedValues.total,
                  };
                } else {
                  obj = {
                    ...obj,
                    free: editedValues.free || 0,
                    total: editedValues.total || 0,
                  };
                }
              } else {
                if (obj.free) {
                  delete obj.free;
                }
                if (obj.total) {
                  delete obj.total;
                }
              }
              addStockQuantity({
                ...obj,
                ...editedValues,
                alertQuantity: isNaN(editedValues.alertQuantity)
                  ? edit.alertQuantity
                  : editedValues.alertQuantity,
                imageUrl: editedValues.imageUrl ?? edit.imageUrl,
                listPrice: editedValues.listPrice ?? edit.listPrice,
                costPrice: editedValues.costPrice ?? edit.costPrice,
                Tags: editedValues.Tags
                  ? editedValues.Tags.map((ta) => ta.trim())
                  : undefined,
              });
            }}
          >
            {t("submit")}
          </Button>
          <Button
            disabled={compareArrays()}
            style={{ marginLeft: 50 }}
            variant="contained"
            color="secondary"
            onClick={() => {
              var o = {};
              setSelectedWarehouse("sfsdf");
              if (edit?.StockItem.StockItemGroups.length) {
                o = {
                  ...o,
                  Tags: edit.StockItem.StockItemGroups.map(
                    (tt) => tt.StockItemGroupName.name
                  ),
                };
              }
              if (edit.StockItem?.PackingDetail?.packages?.length) {
                o = {
                  ...o,
                  packages: edit.StockItem.PackingDetail.packages,
                };
              }
              setEditedValues({ ...o });
              setTimeout(() => {
                setSelectedWarehouse(edit?.Warehouse.name);
              }, [100]);
            }}
          >
            {t("cancel")}
          </Button>
        </div>
      ) : null}
      {edit ? (
        <DialogContent>
          <DialogAppBar
            header={t("stockModule.editItem")}
            onClose={handleExit}
          />
          <Grid container spacing={2} style={{ marginTop: 80 }}>
            <Grid item xs={12} sm={6}>
              {edit.StockItem.imageUrl && !editImgUrl ? (
                <>
                  <img
                    alt={edit.StockItem.name + "-image"}
                    src={formatGoogleDriveMediaLink(edit.StockItem.imageUrl)}
                    style={{ width: 200 }}
                    loading="lazy"
                  />
                  <IconButton
                    onClick={() => {
                      setEditImgUrl(true);
                    }}
                  >
                    <Delete />
                  </IconButton>
                </>
              ) : (
                <Grid item container spacing={3} xs={12}>
                  <Grid item xs={12}>
                    <Typography style={{ fontWeight: "bold" }}>
                      {t("useImageFromExternalSource")}
                    </Typography>
                    <TextField
                      variant="outlined"
                      label={t("stockModule.imageUrl")}
                      placeholder={t("stockModule.imageUrlPlaceholder")}
                      fullWidth
                      onChange={(e, v) => {
                        setEditedValues({
                          ...editedValues,
                          imageUrl: e.target.value,
                        });
                      }}
                    ></TextField>
                  </Grid>
                  <Grid item container xs={12} spacing={1}>
                    <Typography style={{ fontWeight: "bold" }}>
                      {t("uploadImageFromDevice")}
                    </Typography>
                    <Grid item xs={12}>
                      <input
                        accept="image/*"
                        className={classes.input}
                        id="contained-button-file"
                        type="file"
                        onChange={(e) => {
                          if (e.target.files) {
                            setFiles(e.target.files[0]);
                          }
                        }}
                        ref={fileUploadRef}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <label htmlFor="contained-button-file">
                        <Button
                          variant="outlined"
                          disabled={!files}
                          onClick={uploadPhoto}
                        >
                          {t("uploadMedia")}
                        </Button>
                      </label>
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Grid container item xs={12} sm={6} spacing={1}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled
                  label={"SKU"}
                  value={edit.StockItem.sku}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  disabled
                  label={t("stockModule.name")}
                  value={edit.StockItem.name}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0 }}
                  label={t("stockModule.listPrice") + "(€)"}
                  defaultValue={edit.StockItem.listPrice}
                  onChange={(e, v) => {
                    setEditedValues({
                      ...editedValues,
                      listPrice: e.target.value,
                    });
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="number"
                  inputProps={{ min: 0 }}
                  label={t("stockModule.costPrice") + "(€)"}
                  defaultValue={edit.StockItem.costPrice}
                  onChange={(e, v) => {
                    setEditedValues({
                      ...editedValues,
                      costPrice: e.target.value,
                    });
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={12}>
                <>
                  {editedValues && editedValues?.Tags
                    ? getMap().map((ta, i) => (
                        <Grid key={i} item style={{ margin: "6px" }}>
                          <Button
                            style={{
                              fontSize: 12,
                              textAlign: "center",
                              backgroundColor: "lightgrey",
                              padding: 3,
                              borderRadius: 10,
                              zIndex: 1000,
                            }}
                            onClick={(e) => {
                              setEditedValues({
                                ...editedValues,
                                Tags: editedValues.Tags.filter(
                                  (tt) => tt !== ta
                                ),
                              });
                            }}
                            endIcon={<Clear />}
                          >
                            {ta}
                          </Button>
                        </Grid>
                      ))
                    : null}
                </>
                <TagNameSearchAutocomplete
                  reset={autocompKey}
                  onChange={(e, v) => {
                    if (v && v.name) {
                      var arr = editedValues?.Tags || [];
                      arr.push(v.name);
                      setEditedValues({ ...editedValues, Tags: [...arr] });
                      setAutocompKey(Date.now());
                    }
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <DetailTabs
                activeTabs={[
                  {
                    label: t("stockModule.warehouse"),
                    content: (
                      <WarehouseTab
                        selectedWarehouse={selectedWarehouse}
                        setEditedValues={setEditedValues}
                        setSelectedWarehouse={setSelectedWarehouse}
                        edit={edit}
                        editedValues={editedValues}
                        otherWarehouses={otherWarehouses}
                        stockChanges={stockChanges}
                      />
                    ),
                  },
                  {
                    label: t("stockModule.supplierCompany"),
                    content: (
                      <SupplierCompanyTab
                        setEditedValues={setEditedValues}
                        editedValues={editedValues}
                        edit={edit}
                        selectedWarehouse={selectedWarehouse}
                        otherWarehouses={otherWarehouses}
                      />
                    ),
                  },
                  {
                    label: t("stockModule.shippingInformation"),
                    content: (
                      <ShippingInformationTab
                        setEditedValues={setEditedValues}
                        editedValues={editedValues}
                        setEditPackage={setEditPackage}
                        edit={edit}
                        selectedWarehouse={selectedWarehouse}
                      />
                    ),
                  },
                  {
                    label: t("orders.header"),
                    content: (
                      <>
                        <SortableTable
                          header={t("orders.header")}
                          tableLayout={"fixed"}
                          downloadButton={true}
                          headCells={[
                            {
                              id: "Notes",
                              label: "",
                              width: 32,
                              hideFromCsv: true,
                            },
                            {
                              id: "EmailListOrders",
                              label: "",
                              width: 32,
                              hideFromCsv: true,
                            },
                            {
                              id: "updatedAt",
                              numeric: false,
                              disablePadding: false,
                              label: t("updatedAt"),
                              // width: 105,
                            },
                            {
                              id: "createdAt",
                              numeric: false,
                              disablePadding: false,
                              label: t("createdAt"),
                              // width: 105,
                            },
                            {
                              id: "User.fullName",
                              numeric: false,
                              disablePadding: false,
                              label: t("createdBy"),
                            },
                            {
                              id: "invoiceIssuer",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.invoiceIssuer"),
                            },
                            {
                              id: "number",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.orderNumber"),
                            },
                            {
                              id: "paymentStatus",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.paymentStatus"),
                            },
                            {
                              id: "clientInfo",
                              numeric: false,
                              disablePadding: false,
                              label: t("clientInfo"),
                            },
                            {
                              id: "genericDevices",
                              numeric: false,
                              disablePadding: false,
                              label: t("items"),
                            },
                            {
                              id: "Devices",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.allocatedSerialNumbers"),
                            },
                            {
                              id: "depositAmount",
                              numeric: false,
                              disablePadding: false,
                              label: "Backlog",
                            },
                          ]}
                          // disablePagination: true,
                          defaultSortRow={"updatedAt"}
                          handleRowClick={() => {}}
                          getRowStyle={(data) => {
                            var obj = { cursor: "pointer" };
                            var p = paymentStates.find(
                              (f) => data.paymentStatus === f.value
                            );
                            if (p && p.color) {
                              return { ...obj, backgroundColor: p.color };
                            }
                            return obj;
                          }}
                          specialDataFormatting={[
                            {
                              id: "updatedAt",
                              format: (data, d, dd) => {
                                if (dd.Notes && dd.Notes.length) {
                                  const max = dd.Notes.reduce((prev, current) =>
                                    prev && prev.id > current.id
                                      ? prev
                                      : current
                                  );
                                  return formatTimeWithTZOffset(
                                    max.updatedAt,
                                    ECABIN
                                  );
                                }
                                return formatTimeWithTZOffset(data, ECABIN);
                              },
                            },
                            {
                              id: "Notes",
                              format: (data) => {
                                if (data.find((f) => f.User)) {
                                  return (
                                    <Tooltip title={t("activeComments")}>
                                      <ChatIcon
                                        color="primary"
                                        style={{ fontSize: 20 }}
                                      />
                                    </Tooltip>
                                  );
                                }
                                return "";
                              },
                            },
                            {
                              id: "EmailListOrders",
                              format: (data, d, dd) => {
                                if (
                                  data.find(
                                    (f) =>
                                      f &&
                                      f.EmailList?.EmailListUsers.find(
                                        (u) => u.User.id === getUser().userId
                                      )
                                  ) ||
                                  dd.UserId === getUser().userId
                                ) {
                                  return (
                                    <Tooltip title={t("tagged")}>
                                      <NotificationsIcon
                                        color="primary"
                                        style={{ fontSize: 20 }}
                                      />
                                    </Tooltip>
                                  );
                                }
                                return "";
                              },
                            },
                            {
                              id: "createdAt",
                              format: (data) => {
                                return formatTimeWithTZOffset(data, ECABIN);
                              },
                            },
                            {
                              id: "clientInfo",
                              format: (data) => {
                                return formatClientInfoString(data, [
                                  "companyName",
                                  "contactName",
                                  "location",
                                ]);
                              },
                            },
                            {
                              id: "genericDevices",
                              format: (data) => {
                                var x;
                                if (data && data.length > 1) {
                                  x = 0;
                                  data.forEach((d) => (x = x + d.count));
                                  return t("count") + ":" + x;
                                }
                                var a = "";
                                data.forEach(
                                  (v) => (a = v.count + " x " + v.name)
                                );
                                return a;
                              },
                            },
                            {
                              id: "Devices",
                              format: (data, d, dd) => {
                                if (data && data.length) {
                                  return data
                                    .map((m) => m.serialNumber)
                                    .join(" ");
                                }
                                if (
                                  data &&
                                  !data.length &&
                                  dd.genericDevices.find(
                                    (m) =>
                                      m.sku
                                        .toLowerCase()
                                        .includes("ctn_ec_w_220") ||
                                      m.sku
                                        .toLowerCase()
                                        .includes("ctn_ec_g_220")
                                  )
                                ) {
                                  return t("orders.allocationNeeded");
                                }
                                return "";
                              },
                            },
                            {
                              id: "paymentStatus",
                              formatReturnsElement: true,
                              format: (data, e, v) => {
                                if (e === "json") {
                                  return t(
                                    "paymentStates." +
                                      paymentStates.find(
                                        (o) => o.value === data
                                      ).value
                                  );
                                }
                                return (
                                  <ListItem>
                                    {t(
                                      "paymentStates." +
                                        paymentStates.find(
                                          (o) => o.value === data
                                        ).value
                                    )}
                                    {data === "transit" &&
                                    v.multipleShipments ? (
                                      <Tooltip
                                        title={
                                          "This Order has multiple shipments"
                                        }
                                        placement="top"
                                      >
                                        <ListItemIcon size="small">
                                          <InfoIcon
                                            style={{ verticalAlign: "middle" }}
                                            fontSize="small"
                                          />
                                        </ListItemIcon>
                                      </Tooltip>
                                    ) : null}
                                  </ListItem>
                                );
                              },
                            },
                            {
                              id: "invoiceIssuer",
                              format: (data) => {
                                if (!data) {
                                  return "";
                                }
                                return Object.entries(invoiceIssuers).find(
                                  ([k, o], v) => {
                                    if (k === data) return o;
                                    return undefined;
                                  }
                                )[1].name;
                              },
                            },
                            {
                              id: "depositAmount",
                              format: (data, d, row) => {
                                if (
                                  !(
                                    row.paymentStatus === "invoiced" ||
                                    row.paymentStatus === "deposit"
                                  )
                                ) {
                                  return "";
                                }
                                return row.totalPrice - row.depositAmount;
                              },
                            },
                          ]}
                          // handleScrollClick: showDeviceNewTab,
                          tableData={orders.filter((f) =>
                            f.genericDevices.find(
                              (aa) => aa.id === edit.StockItemId
                            )
                          )}
                          rowsPerPage={50}
                        />
                      </>
                    ),
                  },
                  {
                    label: t("resupplyOrders.header"),
                    content: (
                      <>
                        <SortableTable
                          tableLayout={"fixed"}
                          downloadButton={true}
                          header={t("resupplyOrders.header")}
                          headCells={[
                            {
                              id: "Notes",
                              label: "",
                              width: 32,
                              hideFromCsv: true,
                            },
                            {
                              id: "EmailListResupplyOrders",
                              label: "",
                              width: 32,
                              hideFromCsv: true,
                            },
                            {
                              id: "updatedAt",
                              numeric: false,
                              disablePadding: false,
                              label: t("updatedAt"),
                            },
                            {
                              id: "createdAt",
                              numeric: false,
                              disablePadding: false,
                              label: t("createdAt"),
                            },
                            {
                              id: "eta",
                              numeric: false,
                              disablePadding: false,
                              label: "ETA",
                            },
                            {
                              id: "User.fullName",
                              numeric: false,
                              disablePadding: false,
                              label: t("createdBy"),
                            },
                            {
                              id: "invoiceIssuer",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.invoiceIssuer"),
                            },
                            {
                              id: "number",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.orderNumber"),
                            },
                            {
                              id: "paymentStatus",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.paymentStatus"),
                            },
                            {
                              id: "genericDevices",
                              numeric: false,
                              disablePadding: false,
                              label: t("items"),
                            },
                            {
                              id: "totalPrice",
                              numeric: false,
                              disablePadding: false,
                              label: t("orders.totalPrice"),
                            },
                          ]}
                          defaultSortRow={"updatedAt"}
                          handleRowClick={() => {}}
                          getRowStyle={(data) => {
                            var obj = { cursor: "pointer" };
                            var p = paymentStates.find(
                              (f) => data.paymentStatus === f.value
                            );
                            if (p && p.color) {
                              return { ...obj, backgroundColor: p.color };
                            }
                            return obj;
                          }}
                          specialDataFormatting={[
                            {
                              id: "updatedAt",
                              format: (data, d, dd) => {
                                if (dd.Notes && dd.Notes.length) {
                                  const max = dd.Notes.reduce((prev, current) =>
                                    prev && prev.id > current.id
                                      ? prev
                                      : current
                                  );
                                  return formatTimeWithTZOffset(
                                    max.updatedAt,
                                    ECABIN
                                  );
                                }
                                return formatTimeWithTZOffset(data, ECABIN);
                              },
                            },
                            {
                              id: "Notes",
                              format: (data) => {
                                if (data.find((f) => f.User)) {
                                  return (
                                    <Tooltip title={t("activeComments")}>
                                      <ChatIcon
                                        color="primary"
                                        style={{ fontSize: 20 }}
                                      />
                                    </Tooltip>
                                  );
                                }
                                return "";
                              },
                            },
                            {
                              id: "EmailListResupplyOrders",
                              format: (data, d, dd) => {
                                if (
                                  (data &&
                                    data.find(
                                      (f) =>
                                        f &&
                                        f.EmailList?.EmailListUsers.find(
                                          (u) => u.User.id === getUser().userId
                                        )
                                    )) ||
                                  dd.UserId === getUser().userId
                                ) {
                                  return (
                                    <Tooltip title={t("tagged")}>
                                      <NotificationsIcon
                                        color="primary"
                                        style={{ fontSize: 20 }}
                                      />
                                    </Tooltip>
                                  );
                                }
                                return "";
                              },
                            },
                            {
                              id: "createdAt",
                              format: (data) => {
                                return formatTimeWithTZOffset(data, ECABIN);
                              },
                            },
                            {
                              id: "genericDevices",
                              format: (data) => {
                                if (data && data.length > 1) {
                                  var x = 0;
                                  data.forEach((d) => (x = x + d.count));
                                  return t("count") + ":" + x;
                                }
                                var a = "";
                                data.forEach(
                                  (v) => (a = v.count + " x " + v.name)
                                );
                                return a;
                              },
                            },
                            {
                              id: "paymentStatus",
                              format: (data) => {
                                return t(
                                  "paymentStates." +
                                    paymentStates.find((o) => o.value === data)
                                      .value
                                );
                              },
                            },
                          ]}
                          // handleScrollClick: showDeviceNewTab,
                          tableData={resupplys.filter((f) =>
                            f.genericDevices.find(
                              (aa) => aa.id === edit.StockItemId
                            )
                          )}
                          rowsPerPage={50}
                        />
                      </>
                    ),
                  },
                  {
                    label: t("stockModule.deleteItem"),
                    content: (
                      <Grid container spacing={3}>
                        <Grid item xs={12}>
                          <Typography style={{ whiteSpace: "pre-wrap" }}>
                            {t("stockModule.itemDeleteWarning")}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography>
                            {t("stockModule.itemExistsIn")}
                          </Typography>
                          {otherWarehouses
                            .filter((o) => o.StockItem.id === edit.StockItem.id)
                            .map((m) => (
                              <Typography key={m.Warehouse.name}>
                                {
                                  warehouseLocation.find(
                                    (f) => f.value === m.Warehouse.name
                                  ).label
                                }
                              </Typography>
                            ))}
                        </Grid>
                        <Grid item>
                          <Button
                            variant="contained"
                            color="secondary"
                            disabled={
                              otherWarehouses.filter(
                                (o) => o.StockItem.id === edit.StockItem.id
                              ).length > 1 &&
                              !checkRequiredPermissions([
                                USER_GROUPS.SUPER_USER,
                              ])
                            }
                            onClick={() => {
                              deleteStockItem(edit?.StockItem?.id);
                            }}
                          >
                            {t("delete")}
                          </Button>
                        </Grid>
                      </Grid>
                    ),
                  },
                ]}
              />
            </Grid>
          </Grid>
        </DialogContent>
      ) : null}
    </Dialog>
  );
}
